import { defaultTo } from "lodash"
import { getCurrentRole } from "./utils"

export const ProjectStatus = {
    ALL: 0,
    YES: 1,
    NO: 2,
    CREATED: 3,
    SUBMITTED: 4,
    RECOMMENDED: 5,
    REVIEWED: 6,
    APPROVED: 7,
    REJECTED: 8,
    PUBLISHED: 9,
    EDITED: 10,
    CLOSED: 11,
    EGP: 12,
    SENT_FOR_REVIEW: 13,
    REJECTED_BY_RECOMMENDER: 14,
    REJECTED_BY_APPROVER: 15,
    CANCELLED: 16,
    SECONDARY_ESTIMATOR_COMPLETE: 99
}

export const BsrType = {
    BML: 'BML',
    BUILT_UP: 'BUILT_UP'
}

export const UserRole = {
    ADMIN: 1,
    GENERAL_USER: 2,
    BSR_FOCAL: 3,
    HOPA: 4,
    PRIMARY_ESTIMATOR: 5,
    PROJECT_ENGINEER: 6,
    PROJECT_MANAGER: 7,
    PROJECT_DIRECTOR: 8,
    CONTRACTOR: 9,
    DFDFD: 14,
    SUPPLIER: 10,
    AUDIT: 12,
    NEW_ROLE: 17,
    VERIFIER: 11,
    SECONDARY_ESTIMATOR: 14,
    SECONDARY_PROJECT_ENGINEER: 15
}

export const getStatusByRole = () => {
    const role = getCurrentRole()
    switch (role) {
        case UserRole.PRIMARY_ESTIMATOR:
            return [ProjectStatus.CREATED, ProjectStatus.SUBMITTED, ProjectStatus.RECOMMENDED, ProjectStatus.REVIEWED, ProjectStatus.APPROVED] 
        case UserRole.SECONDARY_ESTIMATOR:
            return [ProjectStatus.CREATED, ProjectStatus.SUBMITTED, ProjectStatus.RECOMMENDED, ProjectStatus.REVIEWED, ProjectStatus.APPROVED] 
        case UserRole.PROJECT_ENGINEER:
            return [ProjectStatus.RECOMMENDED, ProjectStatus.REVIEWED, ProjectStatus.APPROVED] 
        case UserRole.SECONDARY_PROJECT_ENGINEER:
            return [ProjectStatus.RECOMMENDED, ProjectStatus.REVIEWED, ProjectStatus.APPROVED]
        case UserRole.PROJECT_MANAGER:
            return [ProjectStatus.RECOMMENDED, ProjectStatus.APPROVED]
         case UserRole.HOPA:
            return [ProjectStatus.APPROVED] 
        default:
            return [ProjectStatus.APPROVED] 

    }
}